/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					// Ridge & Vale: relabel the "Choose options" button to "View Product".
					// Done here (not in Liquid) because this section is rendered via the
					// Section Rendering API, where the template / source-product context is
					// unreliable; the body class is always correct. The choose-options button
					// is uniquely a <quick-view class="product-card--add-to-cart-button">.
					if (document.body.classList.contains('template-product-ridge-vale')) {
						this.querySelectorAll('quick-view.product-card--add-to-cart-button .product-card--add-to-cart-text').forEach(el => {
							el.textContent = 'View Product';
						});
					}

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
